// Open the full screen search box
function openSearch() {
  document.getElementById("searchOverlay").style.visibility = "visible";
  document.getElementById("searchOverlay").style.opacity = 1;
}

// Close the full screen search box
function closeSearch() {
  document.getElementById("searchOverlay").style.opacity = 0;
  document.getElementById("searchOverlay").style.visibility = "hidden";
}